// Tenantra Inc. - Careers: candidate sign in
import { useState } from 'react';
import { Loader2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { toast } from 'sonner';
import api, { apiHelpers } from '@/services/api';
import { setTokens, setUser } from '@/services/auth';
import { CareersLayout } from './CareersLayout';

export default function CandidateLoginPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    try {
      setSubmitting(true);
      const res = await api.post('/auth/login', { email: email.trim().toLowerCase(), password });
      if (res.data.user?.role !== 'candidate') {
        toast.error('This sign in is for job candidates. Landlords sign in at tenantra.ca/login.');
        return;
      }
      setTokens(res.data.access_token, res.data.refresh_token);
      setUser(res.data.user);
      window.location.href = '/careers/portal';
    } catch (err) {
      toast.error(apiHelpers.handleError(err));
    } finally {
      setSubmitting(false);
    }
  };

  const field = 'h-10 text-sm border-slate-300 focus-visible:ring-teal-600 rounded-none';

  return (
    <CareersLayout>
      <div className="max-w-sm">
        <h1 className="font-archivo text-2xl font-bold text-slate-900 mb-1" data-testid="candidate-login-heading">Candidate sign in</h1>
        <p className="text-sm text-slate-500 mb-8">Use the email and password you created when you applied.</p>
        <form onSubmit={submit} className="space-y-4" data-testid="candidate-login-form">
          <div>
            <Label htmlFor="email" className="text-xs text-slate-700">Email</Label>
            <Input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required className={field} data-testid="candidate-login-email" />
          </div>
          <div>
            <Label htmlFor="password" className="text-xs text-slate-700">Password</Label>
            <Input id="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required className={field} data-testid="candidate-login-password" />
          </div>
          <Button type="submit" disabled={submitting} className="w-full h-10 bg-teal-600 hover:bg-teal-700 text-white text-sm font-medium" data-testid="candidate-login-submit">
            {submitting ? <Loader2 className="w-4 h-4 animate-spin" /> : 'Sign in'}
          </Button>
        </form>
        <div className="mt-6 flex items-center justify-between text-xs">
          <a href="/forgot-password" className="text-slate-500 hover:text-slate-800" data-testid="candidate-forgot-link">Forgot password</a>
          <a href="/careers" className="text-teal-700 hover:underline">Open positions</a>
        </div>
      </div>
    </CareersLayout>
  );
}
